import moment from 'moment';
import { useAccountStore } from '~/stores/accountStore';

import 'moment/dist/locale/cs.js';
import 'moment/dist/locale/sk.js';
import 'moment/dist/locale/de.js';
import 'moment/dist/locale/en-gb.js';
import 'moment/dist/locale/pl.js';
import 'moment/dist/locale/hu.js';

export default defineNuxtPlugin({
    name: 'moment-plugin',
    hooks: {
        'vue:setup'() {
            const accountStore = useAccountStore();
            moment.locale(accountStore.state.locale);
        }
    },
});
